import { ReactNode, useId } from 'react';
import { Form } from 'react-bootstrap';

import { Label } from 'components/base/Label';

import './Switch.scss';

interface SwitchProps {
  readonly label: ReactNode;
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
  readonly disabled?: boolean;
  /** Muted guidance rendered under the switch row. */
  readonly helpText?: ReactNode;
}

/**
 * An On/Off toggle laid out as a stretched row: label on the left, the switch and its On/Off state on the right. For a
 * boolean that reads as enabled/disabled rather than a checklist item (e.g. "Case insensitive", "Use regex"); sibling to
 * `EditBoolean`'s checkbox. The external `<label htmlFor>` associates with the switch input across the row.
 */
export const Switch = ({ label, checked, onChange, disabled = false, helpText }: SwitchProps) => {
  const id = useId();
  return (
    <div className="switch-field">
      <div className="switch-field__row">
        <Label htmlFor={id}>{label}</Label>
        <span className="switch-field__control">
          <Form.Check type="switch" id={id} checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
          <span className="switch-field__state">{checked ? 'On' : 'Off'}</span>
        </span>
      </div>
      {helpText !== undefined && <Form.Text className="text-muted">{helpText}</Form.Text>}
    </div>
  );
};
